
import React from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { useTheme } from '../contexts/ThemeContext';

export type AppSection = 'chat' | 'features' | 'journey' | 'profile' | 'insights' | 'kai-settings' | 'library' | 'venn';

interface MainLayoutProps {
  children: React.ReactNode;
  activeSection: AppSection;
  setActiveSection: (section: AppSection) => void;
  user: any;
  logout: () => Promise<void>;
  isFullscreen: boolean;
  toggleFullscreen: () => void;
  userStats?: { streak: number, xp: number, level: number }; // Optional stats
}

export const MainLayout: React.FC<MainLayoutProps> = ({
    children,
    activeSection,
    setActiveSection,
    user,
    logout,
    isFullscreen,
    toggleFullscreen,
    userStats
}) => {
    const { theme } = useTheme();

    return (
        // MOBILE FIX: Use h-[100dvh] (Dynamic Viewport Height) instead of h-screen
        // This accounts for the expanding/collapsing mobile browser URL bar.
        <div className={`flex h-[100dvh] w-full overflow-hidden transition-colors duration-500 ${theme.colors.bg} ${theme.colors.text.main}`}>
            
            {/* Sidebar is now floating, so it sits in the flex container but layout handles padding */}
            <Sidebar 
                activeSection={activeSection} 
                setActiveSection={setActiveSection}
                user={user}
                logout={logout}
                isFullscreen={isFullscreen}
                toggleFullscreen={toggleFullscreen}
                userStats={userStats}
            />

            {/* Main Stage */}
            {/* Removed md:py-[2vh] to allow inner container to manage margins explicitly for alignment */}
            <main className="flex-1 flex flex-col h-full relative overflow-hidden pb-[72px] md:pb-0 md:pr-[2vw] md:pl-4">
                
                {/* Content Card / Container */}
                {/* 
                    Aligned with Sidebar:
                    Sidebar is h-[calc(100dvh-4vh)] with my-[2vh].
                    We replicate this geometry here for perfect alignment.
                */}
                <div className="flex-1 overflow-hidden relative md:h-[calc(100dvh-4vh)] md:my-[2vh]">
                    {children}
                </div>
                
                <MobileNav activeSection={activeSection} setActiveSection={setActiveSection} />
            </main>
        </div>
    );
};
